import React, { useState, useEffect } from "react";
import FormulaireInscription from "@/components/FormulaireInscription/FormulaireInscriptionComponent";
import SocialLogin from "@/components/SocialLogin/SocialLoginComponent";
import { TypeUser } from "@/types/UtilisateurType";
import { User } from "@/types/UserSocialType";
import styles from "./Inscription.module.css";
import { InscriptionProps } from "@/types/InscriptionType";
import * as LucideIcons from "lucide-react";
import SecurityMessage from "../Confidentialite/ConfidentialiteComponent";

const iconMap = {
  CircleCheck: LucideIcons.CircleCheck,
};

export default function InscriptionComponent({
  typeUsers,
  isDisplayConditions = false,
  title,
  description,
  advantages,
  images = {},
  villes,
  configFormulaire,
  initialValues = { email: "", nom: "" },
  onSubmit,
}: InscriptionProps) {
  const [currentType, setCurrentType] = useState<TypeUser>(typeUsers[0]);
  const defaultImage = "/assets/images/cheptel.png";
  const [currentImage, setCurrentImage] = useState(
    images[currentType] || defaultImage
  );

  useEffect(() => {
    setCurrentImage(images[currentType] || defaultImage);
  }, [currentType, images]);

  return (
    <div className={`${styles.container} mx-auto`}>
      <div className={styles.leftColumn}>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.description}>{description}</p>
        {advantages.length > 0 && (
          <ul className={styles.advantages}>
            {advantages.map((advantage, index) => {
              const IconComponent =
                iconMap[advantage.icon as keyof typeof iconMap] ||
                LucideIcons.CircleCheck;
              return (
                <li key={index} className={styles.advantageItem}>
                  <IconComponent className={styles.icon} />
                  <span>{advantage.text}</span>
                </li>
              );
            })}
          </ul>
        )}

        <FormulaireInscription
          isInscription={true}
          typeUser={currentType}
          isDisplayConditions={isDisplayConditions}
          initialValues={initialValues}
          villes={villes}
          configFormulaire={configFormulaire}
          onTypeChange={setCurrentType}
          onSubmit={onSubmit}
        />
        <SocialLogin />
        <SecurityMessage />
      </div>

      <div className={styles.rightColumn}>
        <img
          src={currentImage}
          alt="Illustration de l'inscription"
          className={styles.mainImage}
        />
      </div>
    </div>
  );
}
